enum UserAccountType {
    internal = 1,
    third = 2,
}

export default UserAccountType;
